import { isFlexApp } from "@/hooks/useIsFlexApp";
import { FLEX_BRIDGE_EVENTS, sendToFlexApp } from "@/lib/flexBridge";

/**
 * Safely open an external URL.
 *
 * - Inside the Flex app: delegates to the native shell via the bridge.
 * - Otherwise: falls back to `window.open`.
 */
export function safeOpen(url: string): void {
	if (!url) return;

	if (isFlexApp()) {
		sendToFlexApp(FLEX_BRIDGE_EVENTS.OPEN_EXTERNAL_URL, { url });
	} else {
		window.open(url, "_blank");
	}
}
